import React, {useEffect, Fragment} from 'react'
import { CasoGeneralComponent } from 'defcol-caso-general'
import { useLocation } from 'react-router-dom'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'
import { useDispatch } from 'react-redux'
import { Card, Container } from 'react-bootstrap'
import Administracion from './administracion'

const GestionInformesProfesionales = () => {
    const dispatch = useDispatch()
    const {state} = useLocation()
    const idCasoLocation = state?.row?.IdCaso ? state.row.IdCaso : 1 //127
    const idImplicado = state?.row?.IdImplicado ? state.row.IdImplicado : 0
    const idOrganizacionCaso = state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso : 8600399880

    useEffect(()=>{
        dispatch(obtenerDatosLlaves({idCaso: idCasoLocation, idImplicado: idImplicado, idOrgCaso: idOrganizacionCaso}))
    }, [dispatch])
  
    return (
        <Fragment> 
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                        {`Gestión Informes Profesionales - Caso ${idCasoLocation}`}
                    </Card.Header>
                    <Card.Body>
                        <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} /> 
                    </Card.Body>
                </Card>
            </Container>            
            <Administracion />
        </Fragment>
    )
}
export default GestionInformesProfesionales
